import { jsx } from "@emotion/react/jsx-runtime";
import Icon from "./Icon.mjs";
function renderIcon(props) {
  let moreProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!props) return null;
  if (typeof props === "string") {
    props = {
      name: props
    };
  }
  return /* @__PURE__ */jsx(Icon, {
    ...moreProps,
    ...props
  });
}
export { renderIcon as default };